import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { FullReset } from '../../../../utilities/DL/PersonalQuickReaction';

const MASTER_PASSWORD_REQUIRED = 'evitarborrarregistros456852';

/**
 * COMPONENTE: QuickReactionPersonalDangerModal
 * [HU-06] Modal de Zona Peligrosa - Reinicio Total Maestro de la Sala
 *
 * Exige validación obligatoria de la contraseña maestra 'evitarborrarregistros456852'
 * para ejecutar el vaciado completo de registros, clasificación y telemetría de la dinámica.
 */
export const QuickReactionPersonalDangerModal = ({
    isOpen = false,
    onClose = () => {},
    roomId = '',
    onSuccess = () => {}
}) => {
    const [passwordInput, setPasswordInput] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    useEffect(() => {
        if (isOpen) {
            setPasswordInput('');
            setErrorMessage('');
            setIsSubmitting(false);
        }
    }, [isOpen]);

    const isPasswordValid = passwordInput === MASTER_PASSWORD_REQUIRED;

    const handleConfirmFullReset = async (e) => {
        if (e) e.preventDefault();

        if (!isPasswordValid) {
            setErrorMessage('La contraseña maestra ingresada no es válida.');
            return;
        }

        setIsSubmitting(true);
        setErrorMessage('');

        try {
            const payload = {
                roomId,
                masterPassword: MASTER_PASSWORD_REQUIRED,
                operatorUser: 'admin'
            };

            const response = await FullReset(payload);

            if (response && response.success) {
                if (onSuccess) onSuccess();
                onClose();
            } else {
                setErrorMessage(response?.message || 'Error al ejecutar el reinicio maestro de la sala.');
            }
        } catch (error) {
            console.error('[QuickReactionPersonalDangerModal] Error en FullReset:', error);
            setErrorMessage('Error de conexión al procesar el reinicio de la sala.');
        } finally {
            setIsSubmitting(false);
        }
    };

    if (!isOpen) return null;

    return (
        <div className="QrpModalOverlay" onClick={onClose}>
            <div
                className="QrpModal QrpModal--medium"
                onClick={(e) => e.stopPropagation()}
            >
                {/* Header Peligro */}
                <div className="QrpModal__Header QrpModal__Header--danger">
                    <div className="QrpModal__HeaderTitle">
                        <i className="bi bi-radioactive" />
                        <span>Zona Peligrosa: Reinicio Total Maestro</span>
                    </div>
                    <button
                        type="button"
                        className="QrpModal__CloseBtn"
                        onClick={onClose}
                        title="Cerrar modal"
                    >
                        <i className="bi bi-x-lg" />
                    </button>
                </div>

                {/* Body */}
                <div className="QrpModal__Body">
                    {errorMessage && (
                        <div className="QrpModal__Alert QrpModal__Alert--error">
                            <i className="bi bi-exclamation-triangle-fill" />
                            <span>{errorMessage}</span>
                        </div>
                    )}

                    <div className="QrpModal__DangerWarningBox">
                        <i className="bi bi-shield-exclamation text-danger fs-3 mb-2" />
                        <h6 className="text-danger fw-bold mb-2">¡Acción Destructiva Irreversible!</h6>
                        <p className="mb-0">
                            Esta operación eliminará permanentemente <strong>todos los registros de participantes</strong>,
                            las <strong>jugadas procesadas</strong>, el <strong>ranking oficial</strong> y los <strong>eventos de telemetría</strong> de esta sala.
                        </p>
                    </div>

                    <div className="QrpModal__FieldGroup mt-3">
                        <label className="QrpModal__Label">
                            Introduce la clave maestra de seguridad para autorizar:
                        </label>
                        <input
                            type="password"
                            className={`QrpModal__Input ${isPasswordValid ? 'QrpModal__Input--valid' : ''}`}
                            placeholder="Introduce la contraseña maestra..."
                            value={passwordInput}
                            onChange={(e) => setPasswordInput(e.target.value)}
                            autoFocus
                        />
                        <span className="QrpModal__FieldHelp">
                            Clave de seguridad del sistema requerida.
                        </span>
                    </div>
                </div>

                {/* Footer */}
                <div className="QrpModal__Footer">
                    <button
                        type="button"
                        className="QrpModal__Btn QrpModal__Btn--secondary"
                        onClick={onClose}
                        disabled={isSubmitting}
                    >
                        Cancelar
                    </button>
                    <button
                        type="button"
                        className="QrpModal__Btn QrpModal__Btn--danger"
                        onClick={handleConfirmFullReset}
                        disabled={!isPasswordValid || isSubmitting}
                    >
                        {isSubmitting ? (
                            <>
                                <span className="spinner-border spinner-border-sm me-2" />
                                <span>Borrando registros...</span>
                            </>
                        ) : (
                            <>
                                <i className="bi bi-trash-fill me-2" />
                                <span>Ejecutar Borrado Total</span>
                            </>
                        )}
                    </button>
                </div>
            </div>
        </div>
    );
};

QuickReactionPersonalDangerModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    roomId: PropTypes.string,
    onSuccess: PropTypes.func
};

export default QuickReactionPersonalDangerModal;
